// Evenimente pentru Google Analytics (GA4). Dacă gtag nu e încărcat (cookie-uri refuzate), nu face nimic.
export function trackEvent(name, params = {}) {
    try {
        if (typeof window.gtag === 'function') {
            window.gtag('event', name, params);
        }
    } catch {
        // Măsurarea nu trebuie să strice niciodată pagina.
    }
}
